import { TooltipText } from 'components/shared/TooltipText';
import React from 'react';
import { empty } from '../JsonFrame';
import { JsonContentValidationMessage } from './JsonContentValidationMessage';

interface UrlTypeProps {
  val: string;
}

export const UrlType: React.FunctionComponent<UrlTypeProps> = (props): JSX.Element => {
  return !empty(props.val) ? (
    <div>
      <a href={props.val} target="blank" rel="noopener noreferrer">
        {props.val}
      </a>
    </div>
  ) : (
    <JsonContentValidationMessage message={TooltipText.urlTypeValidationMessage} />
  );
};
